import { render, staticRenderFns } from "./ResourceCalendar.vue?vue&type=template&id=7a701cbd&scoped=true"
import script from "./ResourceCalendar.vue?vue&type=script&lang=js"
export * from "./ResourceCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a701cbd",
  null
  
)

export default component.exports